import axios from 'axios'
import { VERIFICAR_PAGAMENTO_PIX_FECHAMENTO_CAIXA } from '../../types'
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil'
import { URL } from '../../../util/ambienteActions';

export default function verificarPagamentoPixFechamentoCaixa (fechamentoCaixaId, codigoEmpresa) {
  const url = `${URL}/fechamento-caixa-usuario/${fechamentoCaixaId}/empresa/${codigoEmpresa}/pix/status`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: VERIFICAR_PAGAMENTO_PIX_FECHAMENTO_CAIXA,
        payload: response
      })
  );
}
